import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import AuditsPanelFull from './AuditsPanelFull';
import AuditsPanelNarrow from './AuditsPanelNarrow';

const AuditsPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: AuditsPanelFull, narrow: AuditsPanelNarrow }}
    onChange={onChange}
  />
);

export default AuditsPanel;
